import { InputAlert } from '@creditornot/cb-input';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { PartialExportedMenu, readAndParseFile } from 'modules/menu/components/ImportMenuModal/utils';
import { trackSelectXmenuJSONForImport } from 'modules/shared-menu/telemetry';

import { XmenuJsonDropzone } from '../../pages/SharedMenuEditorPage/components/Collections/VenueXmenuImport/XmenuJsonDropzone';

type XmenuFileSelectorProps = {
  setImportData: (menuData: PartialExportedMenu) => void;
};

const Root = styled.div`
  padding: 0 24px 24px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const XmenuFileSelector = ({ setImportData }: XmenuFileSelectorProps) => {
  const intl = useIntl();

  const [fileName, setFileName] = useState<string | undefined>(undefined);
  const [fileError, setFileError] = useState<string | undefined>(undefined);

  const handleFileChange = async (files: File[]) => {
    if (files.length > 0) {
      await readAndParseFile(files[0], intl)
        .then(menuImportData => setImportData(menuImportData))
        .then(() => trackSelectXmenuJSONForImport('Success'))
        .catch(error => {
          setFileError(error);
          trackSelectXmenuJSONForImport(`Failure: ${error}`);
        });
    }
  };

  return (
    <Root>
      <XmenuJsonDropzone
        fileName={fileName}
        onDrop={files => {
          setFileError(undefined);
          setFileName(files[0].name);
          if (!files[0].name.endsWith('.json')) {
            setFileError(intl.formatMessage({ id: 'menu.fileMustBeJson' }));
            trackSelectXmenuJSONForImport('Failure: wrong file extension');
          } else {
            handleFileChange(files);
          }
        }}
        hasError={!!fileError}
        loading={false}
      />
      {!!fileError && (
        <InputAlert style={{ marginBlockStart: 8 }} variant="error">
          {fileError}
        </InputAlert>
      )}
    </Root>
  );
};
